import { Component, OnInit, ViewChild } from '@angular/core';
import { NavController, NavParams, AlertController, ToastController } from "ionic-angular";
import { SmartanimationProvider } from "../../providers/smartanimation/smartanimation";
import { AngularFireDatabase } from "angularfire2/database";
import { AuthProvider } from "../../providers/authservice/auth";
import { CustomerServersPage } from "../customer-servers/customer-servers";
import { Observable } from 'rxjs/Observable';
import { PushOptions, PushObject, Push } from '@ionic-native/push';
import { Device } from '@ionic-native/device';
import { SpecialsdashboardPage } from "../specialsdashboard/specialsdashboard";
import { WelcomePage } from "../welcome/welcome";
import { CustomerNotificationsPage } from "../customer-notifications/customer-notifications";

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage implements OnInit {
  @ViewChild('mainContent') mainContent;
  @ViewChild('headAnimate') headAnimate;
  items: Observable<{}[]>;
  today: Date = new Date();
  _items: any;
  reasurentAddress: any = {};
  featuredImages: any;
  loading: boolean = true;
  loadingLogos: boolean = true;
  loadingFeatured: boolean = true;
  uid: any;
  protected Logo: any[];
  userObj: any;
  restId: string;
  server: any;
  allowedtoConnect: boolean = true;
  user: any;
  isHome: boolean;
  custConnectedRest: any;
  isSameRest: boolean = true;
  notificationCount: number = 0;
  isOpenTableWaiter: boolean = false;

  constructor
    (
    public navCtrl: NavController,
    public animateService: SmartanimationProvider,
    public navPrams: NavParams,
    public af: AngularFireDatabase,
    public authProvider: AuthProvider,
    public alertCtrl: AlertController,
    private push: Push,
    private db: AngularFireDatabase,
    private device: Device,
    private toastContrl: ToastController
    ) {

    this.user = JSON.parse(localStorage.getItem('UserId'));
    this.userObj = JSON.parse(localStorage.getItem('UserObj'));
    console.log('Home');
    if (!localStorage.getItem('chktok'))
      this.pushnotification();
    this.server = JSON.parse(localStorage.getItem('server'));
    if (this.userObj == null) {
      return;
    }
    else {
      this.allowedtoConnect = !((this.userObj.clientId && this.userObj.clientId.length > 0) || (this.userObj.waiterTo && this.userObj.waiterTo.length > 0));
    }
  }

  gotoWelcome() {
    this.navCtrl.setRoot(WelcomePage);
  }

  // Notification Request
  request(itemType) {
    let message = '';
    switch (itemType) {
      case 1:
        message = 'Drinks';
        break;
      case 2:
        message = 'Ready to order';
        break;
      case 3:
        message = 'Coffee / Dessert';
        break;
      case 4:
        message = 'Check Please';
        break;
      default:
        message = 'Error please report admin';
        break;
    }

    let sender = this.user ? this.user.uid : this.device.uuid;
    let path = 'Orders/' + this.restId + '/';
    let tableId = localStorage.getItem('tableId');

    let ref = this.db.database.ref(path).push({ customerId: sender, customerMessage: message, waiterId: this.server.userUID, tableId: tableId, itemType: itemType, waiterMessage: '', chekId: this.custConnectedRest.chekId });

    this.db.database.ref('notifications/').push({ message: message, receiver: this.server.userUID, sender: sender, tableId: tableId, itemType: itemType, orderId: ref.key })
      .then(res => {
        let toast = this.toastContrl.create({
          message: 'Notified to Server',
          duration: 2000,
          position: 'bottom'
        });
        toast.present();
      });

    let waiterCountPath = 'waiterordercount/' + this.server.userUID + '/' + itemType;
    let isModified = false;

    this.af.object(waiterCountPath).valueChanges().subscribe(res => {
      console.log(isModified);
      let count = (res == null || res == undefined) ? 0 : res as number;
      count = count + 1;
      if (!isModified) {
        isModified = true;
        this.af.object(waiterCountPath).set(count);
      }

    });
  }

  // Push Notification
  pushnotification() {
    console.log('pushnotification');
    const options: PushOptions = {
      android: {
        senderID: '976547392808'
      },
      ios: {
        alert: 'true',
        badge: false,
        sound: 'true'
      },
    };

    const pushObject: PushObject = this.push.init(options);

    pushObject.on('notification').subscribe((notification: any) => {
      this.alert(notification.message)
    });

    pushObject.on('registration').subscribe((registration: any) => {
      console.log(registration.registrationId);
      let senderid = registration.registrationId;
      localStorage.setItem('chktok', senderid);
      let uid = this.authProvider.currentUser ? this.authProvider.currentUser.uid : this.device.uuid;
      this.db.database.ref('tokens/' + uid).set(senderid);
    });
  }

  alert(message: string) {
    this.alertCtrl.create({
      title: 'Notification!',
      subTitle: message,
      buttons: ['OK']
    }).present();
  }

  ngOnInit() {

  }

  // Disconnect Server
  disconnectServer() {
  
    if (this.custConnectedRest && this.custConnectedRest.chekId)
      this.af.object('chekIds/' + this.custConnectedRest.chekId + '/isAvailable').set(false);
    this.server = undefined;
    localStorage.removeItem('server');
    localStorage.removeItem('tableId');
    localStorage.removeItem('connectedRestnt');

    if (this.custConnectedRest.key == '-1')
      this.navCtrl.setRoot(WelcomePage);
  }

  // Connect Server
  connectServer() {
    this.navCtrl.push(CustomerServersPage, { resId: this.restId, resturenData: this.navPrams.get('resturenData') });
  }

  // Main Content Loading
  ionViewWillEnter() {
    this.isOpenTableWaiter = (this.server != undefined || this.server != null) && this.server.waiterTo == "-1";

    this.custConnectedRest = JSON.parse(localStorage.getItem('connectedRestnt'));
    this.animateService.smartAnimation().setType('fadeIn').show(this.headAnimate.nativeElement).then(() => {
      this.animateService.smartAnimation().setType('fadeIn').show(this.mainContent.nativeElement).then(() => {
        console.log(this.authProvider);
        let data = this.navPrams.get('resturenData');
        // Main if block
        if (!data || data === 'undefined') {
          this.isHome = true;
          // Params data is empty or undefined

          // if user not authenticated
          if (!this.authProvider.authenticated)
            return;


          this.uid = this.userObj.clientId ? this.userObj.clientId : this.userObj.waiterTo ? this.userObj.waiterTo : '';
          if (this.uid == null || this.uid.length == 0)
            return;
          console.log("restaurant #" + this.uid);
          this.loadingLogos = true;

          // Logos
          this.af.list('restaurants/' + this.uid + '/Logo').valueChanges().subscribe(t => {
            this.Logo = t;
            this.loadingLogos = false;
            console.log(typeof (this.Logo))
            console.log('logo' + this.Logo)
          });

          // Restaurants
          this.af.list('restaurants/' + this.uid + '/Featured').valueChanges().subscribe(t => {
            this.featuredImages = t;
            this.loadingFeatured = false;

          });

          // Address
          this.af.object('restaurants/' + this.uid + '/Address').valueChanges().subscribe(t => {
            this.reasurentAddress = t;
            console.log(this.reasurentAddress);
          });

          this.restId = this.userObj.clientId;
          this.items = this.af.list('specials/' + this.userObj.clientId).valueChanges();
          this.items.subscribe((data) => {
            this._items = data;
            console.log(this._items);
          });
          this.loading = false;
        }
        else {
          this.isHome = false;
          let items;

          if (typeof data.Featured !== 'undefined')
            items = Object.keys(data.Featured).map(function (items) {
              return data.Featured[items];
            });

          this.featuredImages = items;
          console.log(items);
          let logoItem;
          if (typeof data.Logo !== 'undefined') {
            logoItem = Object.keys(data.Logo).map(function (item) {
              return data.Logo[item];
            });
          }
          this.Logo = logoItem;
          console.log(this.Logo);
          this.reasurentAddress = data.Address;
          this.restId = data.key;
          this.isSameRest = !this.custConnectedRest || (this.custConnectedRest.key == this.restId);
          console.log(data.key);
          var path= data.key != "-1" ? 'specials/' + data.key : 'restaurants/-1/servers/' + this.server.userUID + '/specials';

          this.items = this.af.list(path).valueChanges();
          this.items.subscribe((data) => {
            this._items = data;
            console.log(this._items);
            this.loading = false;
          });

          this.loading = false;

          if (this.custConnectedRest && this.custConnectedRest.chekId) {
            let chekId = this.custConnectedRest.chekId;
            this.af.list('Orders/' + this.restId, ref => {
              let obj = ref.orderByChild("chekId").equalTo(chekId);
              return obj;
            }).snapshotChanges().subscribe(data => {
              for (let i = 0; i < data.length; i++)
                if (data[i].type == 'child_changed') {
                  data[i].type = 'value';
                  this.notificationCount++;
                }
            });
          }
        }
      });

    });

  }

  gotoNotification() {
    this.notificationCount = 0;
    if (typeof this.custConnectedRest !== 'undefined' && this.custConnectedRest !== null)
      this.navCtrl.push(CustomerNotificationsPage, { chekId: this.custConnectedRest.chekId, restId: this.restId });
  }

  goToEditSpecial(special: any) {
    this.navCtrl.push(SpecialsdashboardPage, { specialItem: special })
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts